export default __webpack_public_path__ + "776a1246d9a62284239830ada923b3ee.svg";